"use strict";
/**
 * @file Popup Container Provider
 * @desc 指定子树中所有会渲染弹出框的组件（`Select`、`Dropdown` 等）的 popup container 逻辑
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPopupContainer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var getDefaultPopupContainer = function () { return window.document.body; };
var getPopupContainerCtx = react_1.createContext(null);
/** 从上下文得到“获取 popup container 的函数” */
function useGetPopupContainer(fnFromProps) {
    var getPopupContainer = react_1.useContext(getPopupContainerCtx);
    return react_1.useCallback(function (node) {
        var _a, _b;
        return ((_b = (_a = fnFromProps === null || fnFromProps === void 0 ? void 0 : fnFromProps(node)) !== null && _a !== void 0 ? _a : getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer(node)) !== null && _b !== void 0 ? _b : getDefaultPopupContainer());
    }, [fnFromProps, getPopupContainer]);
}
exports.useGetPopupContainer = useGetPopupContainer;
/** 向子树提供 popup container */
function PopupContainerProvider(_a) {
    var containerRef = _a.containerRef, getContainerFromProps = _a.getContainer, children = _a.children;
    var getContainerFromRef = react_1.useCallback(function () { var _a; return (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) !== null && _a !== void 0 ? _a : null; }, [containerRef]);
    var getContainer = getContainerFromProps !== null && getContainerFromProps !== void 0 ? getContainerFromProps : getContainerFromRef;
    return (react_1.default.createElement(getPopupContainerCtx.Provider, { value: getContainer }, children));
}
exports.default = PopupContainerProvider;
//# sourceMappingURL=PopupContainerProvider.js.map